export default __webpack_public_path__ + "static/media/blog-dummy.5875a7b8.png";